exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.colored[data-v-4c62072e] {\n  background-color: #eeeeee;\n}\n.spin[data-v-4c62072e] {\n  animation: rotate-4c62072e 1s infinite linear;\n}\n@keyframes rotate-4c62072e {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n", ""]);

